import { z } from "zod";

import type { IFirebaseUserRepository } from "@/core/repositories/interfaces/IFirebaseUserRepository";
import type { IFirebaseUserService } from "@/core/services/interfaces/IFirebaseUserService";
import type {
  ListFirebaseUsersInput,
  ListFirebaseUsersResult,
  PreferenceStatsResult,
} from "@/core/services/types/firebase-user.types";

const listSchema = z.object({
  q: z.string().optional(),
  pageSize: z.number().int().positive().max(100).optional(),
  pageToken: z.string().nullable().optional(),
});

export class FirebaseUserService implements IFirebaseUserService {
  constructor(private readonly repository: IFirebaseUserRepository) {}

  async list(
    input: ListFirebaseUsersInput = {},
  ): Promise<ListFirebaseUsersResult> {
    const parsed = listSchema.safeParse(input);
    if (!parsed.success) {
      console.error(
        "[FirebaseUserService.list] validation",
        parsed.error.flatten(),
      );
      return { users: [], nextPageToken: null, total: 0 };
    }

    return this.repository.list({
      q: parsed.data.q?.trim() || undefined,
      pageSize: parsed.data.pageSize,
      pageToken: parsed.data.pageToken ?? null,
    });
  }

  async listPreferenceStats(): Promise<PreferenceStatsResult> {
    return this.repository.listPreferenceStats();
  }
}
